/**
 * SEPET OTURUM ANAHTARI
 *
 * Misafir sepetinin kimliğidir ve aynı zamanda ona erişim yetkisidir:
 * bu yüzden tahmin edilemez olmalıdır. Bir kez üretilir, tarayıcıda kalır
 * ve her sepet isteğinde `X-Cart-Session` başlığıyla gönderilir.
 *
 * Sepetin kendisi backend'de yaşar; burada yalnızca anahtar tutulur.
 */

const STORAGE_KEY = 'hc.cartSession';

function createSessionId(): string {
  // 32 karakter, backend'in beklediği [A-Za-z0-9_-]{16,64} biçiminde.
  return crypto.randomUUID().replace(/-/g, '');
}

export function getCartSessionId(): string {
  const existing = localStorage.getItem(STORAGE_KEY);

  if (existing && /^[A-Za-z0-9_-]{16,64}$/.test(existing)) {
    return existing;
  }

  const created = createSessionId();
  localStorage.setItem(STORAGE_KEY, created);
  return created;
}

/**
 * Sipariş tamamlandıktan sonra yeni bir sepet oturumu başlatılır.
 * Eski sepet backend'de kapalı olarak kalır (denetim izi korunur).
 */
export function rotateCartSessionId(): string {
  const created = createSessionId();
  localStorage.setItem(STORAGE_KEY, created);
  return created;
}
